// extracted by mini-css-extract-plugin
export var base = "_13-0";
export var updateBanner = "_13-1";